import { setGlobalContext } from "modules/monitoring";
import { useSelector } from "react-redux";
import {
  selectAdBlockResult,
  selectDailyResult,
  selectFirebaseResult,
  selectFirebaseStorageResult,
  selectFirestoreResult,
  selectHaveChecksBeenRun,
  selectInternetSpeedResult,
  selectIsBrowserSupported,
  selectIsLoading,
  selectIsOSSupported,
  selectIsSuccessful,
  selectReachabilityResult,
  selectVPNDetectionResult,
} from "../../redux/selectors";

interface GeartestResult {
  downloadSpeedMbps: number;
  success: boolean;
  tests: {
    adBlock: boolean;
    browser: boolean;
    firebase: boolean;
    firebaseStorage: boolean;
    firestore: boolean;
    internetSpeed: boolean;
    daily: boolean;
    os: boolean;
    vpn: boolean;
    reachability: boolean;
  };
}

const setGeartestGlobalContext = (geartest: GeartestResult) =>
  setGlobalContext("geartest", geartest);

export const GeartestMonitoring = () => {
  const adBlockResult = useSelector(selectAdBlockResult);
  const vpnResult = useSelector(selectVPNDetectionResult);
  const internetSpeedResult = useSelector(selectInternetSpeedResult);
  const isBrowserSupported = useSelector(selectIsBrowserSupported);
  const isGeartestCompleted = useSelector(selectHaveChecksBeenRun);
  const isGeartestLoading = useSelector(selectIsLoading);
  const isGeartestSuccessful = useSelector(selectIsSuccessful);
  const isOsSupported = useSelector(selectIsOSSupported);
  const firebaseResult = useSelector(selectFirebaseResult);
  const dailyResult = useSelector(selectDailyResult);
  const firestoreResult = useSelector(selectFirestoreResult);
  const firebaseStorageResult = useSelector(selectFirebaseStorageResult);
  const reachabilityResult = useSelector(selectReachabilityResult);

  if (isGeartestLoading || !isGeartestCompleted) {
    return null;
  }

  setGeartestGlobalContext({
    success: Boolean(isGeartestSuccessful),
    downloadSpeedMbps: internetSpeedResult.downloadSpeedMbps ?? 0,
    tests: {
      adBlock: Boolean(adBlockResult.isSuccessful),
      browser: isBrowserSupported,
      firebase: Boolean(firebaseResult.isSuccessful),
      firebaseStorage: Boolean(firebaseStorageResult.isSuccessful),
      firestore: Boolean(firestoreResult.isSuccessful),
      internetSpeed: Boolean(internetSpeedResult.isSuccessful),
      daily: Boolean(dailyResult.isSuccessful),
      os: isOsSupported,
      vpn: Boolean(vpnResult.isSuccessful),
      reachability: Object.values(reachabilityResult).every(
        (result) => result.isSuccessful,
      ),
    },
  });

  return null;
};
